module.exports = __webpack_public_path__ + "img/dealboard-logo-white.005b7901.png";